let _ = t => t,
  _t;
import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { colors, fontSize, fontWeights } from '@ovpn-ui/styles';
export const Link = styled(RouterLink)(_t || (_t = _`
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 8px 16px;

    color: ${0};
    font-weight: ${0};
    font-size: ${0};
    font-family: 'Inter', sans-serif;
    line-height: ${0};

    white-space: nowrap;
    text-decoration: none;

    column-gap: 8px;

    cursor: pointer;

    user-select: none;

    &:hover {
        color: ${0};

        background-color: ${0};

        border-radius: 4px;

        svg {
            color: ${0};
        }
    }
`), colors.neutralTextSubtitle, fontWeights.regular, fontSize.small, fontSize.xMedium, colors.neutralTextSection, colors.neutralBgHover, colors.neutralTextSection);